import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams, useHistory } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';

import { BackButton } from '../../components/Button';
import { DriverForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';
import { CONFIG } from '../../utils/constants';

export default function EditDriver({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const driver = useSelector((state) => state.driver);
  const employee = useSelector((state) => state.employee);
  const vehicle = useSelector((state) => state.vehicle);

  const history = useHistory();
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      employee: driver.employee,
      vehicle: driver.vehicle,
    },
  });

  useEffect(() => {
    dispatch(actions.driverGet(id));
    dispatch(actions.vehicleAll({ size: CONFIG.infiniteLimit }));
    dispatch(actions.employeeAll({ size: CONFIG.infiniteLimit }));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      console.log(data);
      await dispatch(actions.driverPut(id, data));
      await dispatch(actions.driverGet(id));
      alert('สำเร็จ');
      history.goBack();
    } catch (error) {
      console.log(error);
    }
  };

  if (
    driver.isLoading ||
    driver.rows ||
    employee.isLoading ||
    vehicle.isLoading
  ) {
    return <Loading />;
  }
  if (
    !driver.isLoading &&
    driver.isCompleted &&
    !employee.isLoading &&
    employee.isCompleted &&
    !vehicle.isLoading &&
    vehicle.isCompleted
  ) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <DriverForm
                errors={errors}
                employee={employee}
                vehicle={vehicle}
                driver={driver}
                control={control}
                Controller={Controller}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

EditDriver.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditDriver.defaultProps = {
  title: '',
  subtitle: '',
};
